import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
import config from '@/config'
import { canViewIndex, canViewEq, canViewUser } from '../utils/permission'

const rulers = [{
  match: '*',
  except: [
    '/user/login',
    '/exception/403',
    '/exception/404'
  ],
  handler: async function (route, next) {
    canViewIndex()
    if (this.except.includes(route.path)) {
      next(true)
    } else {
      if (store.state.sessionToken) {
        if (route.path === '/') {
          if (config.warehouseId) {
            next(`/grainstore/detail?store=${config.warehouseId}&type=summary`)
          }
          if (canViewIndex()) {
            next(true)
          } else {
            next('/graindepot')
          }
        } else if (route.path === '/equipment') {
          if (canViewEq()) {
            next(true)
          } else {
            next('/graindepot')
          }
        } else if (route.path === '/users') {
          if (canViewUser()) {
            next(true)
          } else {
            next('/graindepot')
          }
        } else if (route.path === '/graindepot' && store.getters.isWarehouseAdmin && store.state.warehouseId) {
          // 如果是库级管理员访问粮库管理页面，且已经获取到了所属的粮库ID
          next(`/grainstore?depot=${store.state.warehouseId}`)
        } else {
          next(true)
        }
      } else {
        next('/user/login')
      }
    }
  },
  fallbackUrl: '/exception/403'
}]

VueTk.tkRouterAuth.init(rulers, router)
